
<template>
  <div class="container-fluid">
    <div class="our-clients">

      <h3 class="mb-4">العملاء</h3>
        <div class="cities__header d-flex">
          <div style="flex: 1">
            <el-input
              @input="searchInClients"
              prefix-icon="el-icon-search"
              placeholder="بحث في العملاء"
              v-model="search"
            ></el-input>
          </div>
          <div>
            <el-button type="primary" @click="addUserModel = true">
              إضافة
            </el-button>
          </div>
        </div>

      <!-- <div class="client-header d-flex mt-2">
        <div>
          <h3 class="mt-2">العملاء</h3>
        </div>
        <div class="d-flex mt-2" style="gap: 10px">
          <div>
            <el-input
              @keyup.enter.native="searchInClients"
              prefix-icon="el-icon-search"
              placeholder="بحث في العملاء"
              v-model="search"
            ></el-input>
          </div>
          <div>
            <el-button @click="addUserModel = true">إضافة</el-button>
          </div>
        </div>
      </div> -->

      <div class="row mt-4">
        <div class="col-md-4" v-for="client in clients" :key="client.id">
          <div class="user mb-2">
            <div class="d-flex head">
              <div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  xmlns:svgjs="http://svgjs.com/svgjs"
                  version="1.1"
                  width="25"
                  height="25"
                  x="0"
                  y="0"
                  viewBox="0 0 512 512"
                  style="enable-background: new 0 0 512 512"
                  xml:space="preserve"
                >
                  <g>
                    <g xmlns="http://www.w3.org/2000/svg">
                      <g>
                        <path
                          d="M437.02,330.98c-27.883-27.882-61.071-48.523-97.281-61.018C378.521,243.251,404,198.548,404,148    C404,66.393,337.607,0,256,0S108,66.393,108,148c0,50.548,25.479,95.251,64.262,121.962    c-36.21,12.495-69.398,33.136-97.281,61.018C26.629,379.333,0,443.62,0,512h40c0-119.103,96.897-216,216-216s216,96.897,216,216    h40C512,443.62,485.371,379.333,437.02,330.98z M256,256c-59.551,0-108-48.448-108-108S196.449,40,256,40    c59.551,0,108,48.448,108,108S315.551,256,256,256z"
                          fill="#000000"
                          data-original="#000000"
                        />
                      </g>
                    </g>
                    <g xmlns="http://www.w3.org/2000/svg"></g>
                    <g xmlns="http://www.w3.org/2000/svg"></g>
                    <g xmlns="http://www.w3.org/2000/svg"></g>
                    <g xmlns="http://www.w3.org/2000/svg"></g>
                    <g xmlns="http://www.w3.org/2000/svg"></g>
                    <g xmlns="http://www.w3.org/2000/svg"></g>
                    <g xmlns="http://www.w3.org/2000/svg"></g>
                    <g xmlns="http://www.w3.org/2000/svg"></g>
                    <g xmlns="http://www.w3.org/2000/svg"></g>
                    <g xmlns="http://www.w3.org/2000/svg"></g>
                    <g xmlns="http://www.w3.org/2000/svg"></g>
                    <g xmlns="http://www.w3.org/2000/svg"></g>
                    <g xmlns="http://www.w3.org/2000/svg"></g>
                    <g xmlns="http://www.w3.org/2000/svg"></g>
                    <g xmlns="http://www.w3.org/2000/svg"></g>
                  </g>
                </svg>
              </div>
              <div>
                <h4>{{ client.name }}</h4>
              </div>
            </div>

            <h6 class="d-flex mt-2" style="gap: 15px">
              <div>
                <h5>العنوان</h5>
              </div>
              <div>
                <h6>
                  {{ client.address }}
                </h6>
              </div>
            </h6>

            <h6 class="d-flex mt-2" style="gap: 15px">
              <div>
                <h5>الهاتف</h5>
              </div>
              <div>
                <h6>
                  {{ client.phone }}
                </h6>
              </div>
            </h6>


            <h6 class="d-flex mt-2" style="gap: 15px">
              <div class="d-flex" style="gap: 15px; align-items: center">
                <h5>الاقساط</h5>
                <h6>{{ convertNumber(client.totalInstallmentAmount) }}</h6>
              </div>
              <div class="d-flex" style="gap: 15px; align-items: center">
                <h5>باقي السداد</h5>
                <h6>{{convertNumber(client.totalInstallmentAmount- client.totalPaiedAmount) }}</h6>
              </div>
            </h6>
            <div  style="margin-right: 90%;margin-top:-30px;">
                     <el-popconfirm v-if="(client.totalInstallmentAmount- client.totalPaiedAmount)==0"
                    confirm-button-text="موافق"
                    cancel-button-text="إلغاء"
                    icon="el-icon-info"
                    icon-color="red"
                    :title="'هل تريد حذف ' + ' ' + client.name + ' ؟'"
                    @confirm="destroy(client)"
                  >
                    <div slot="reference">
                      <el-button
                        title="حذف"
                        type="danger"
                        size="mini"
                        icon="el-icon-delete"
                      ></el-button>
                    </div>
                  </el-popconfirm>
                  </div>



            <!-- <div class="locations__actions">
                  <div class="actions mb-0 mt-2 text-right">
                    <div>
                      <button
                        
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          id="Icon"
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                        >
                          <rect
                            id="Area"
                            width="20"
                            height="20"
                            fill="#fcfcfc"
                            opacity="0"
                          />
                          <g
                            id="Icon-2"
                            data-name="Icon"
                            transform="translate(1.566 1.566)"
                          >
                            <path
                              id="Path"
                              d="M9.167,3.333H15A1.667,1.667,0,0,1,16.667,5V16.667A1.666,1.666,0,0,1,15,18.333H3.334a1.667,1.667,0,0,1-1.667-1.666V10.833"
                              transform="translate(0.101 -1.566)"
                              fill="none"
                              stroke="#919efa"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="1.667"
                            />
                            <path
                              id="Path-2"
                              data-name="Path"
                              d="M9.684,2.083a1.768,1.768,0,0,0-2.5,2.5L15.1,12.5l3.333.833L17.6,10Z"
                              transform="translate(-6.667 -1.566)"
                              fill="none"
                              stroke="#919efa"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="1.667"
                            />
                          </g>
                        </svg>
                      </button>
                    </div>

                    <div>
                      <el-popconfirm
                        :title="
                          'هل أنت متأكد من الحذف ؟'
                        "
                        
                        :cancel-button-text="
                          'إلغاء'
                        "
                        :confirm-button-text="
                            'حذف'
                        "
                      >
                        <button slot="reference">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            id="Icon"
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                          >
                            <rect
                              id="Area"
                              width="20"
                              height="20"
                              fill="#fcfcfc"
                              opacity="0"
                            />
                            <g
                              id="Icon-2"
                              data-name="Icon"
                              transform="translate(2.5 1.667)"
                            >
                              <path
                                id="Path"
                                d="M17.5,5H2.5"
                                transform="translate(-2.5 -1.667)"
                                fill="none"
                                stroke="red"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="1.667"
                              />
                              <path
                                id="Path-2"
                                data-name="Path"
                                d="M4.167,5V16.667a1.666,1.666,0,0,0,1.666,1.666h8.334a1.666,1.666,0,0,0,1.666-1.666V5m-2.5,0V3.333a1.666,1.666,0,0,0-1.666-1.666H8.333A1.666,1.666,0,0,0,6.667,3.333V5"
                                transform="translate(-2.5 -1.667)"
                                fill="none"
                                stroke="red"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="1.667"
                              />
                              <line
                                id="Line"
                                y2="5"
                                transform="translate(9.167 7.5)"
                                fill="none"
                                stroke="red"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="1.667"
                              />
                              <line
                                id="Line-2"
                                data-name="Line"
                                y2="5"
                                transform="translate(5.833 7.5)"
                                fill="none"
                                stroke="red"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="1.667"
                              />
                            </g>
                          </svg>
                        </button>
                      </el-popconfirm>
                    </div>
                  </div>
                </div> -->


          </div>
        </div>
      </div>
    </div>

    <vs-popup
      class="popup-width-300"
      title=" إضافة عميل"
      :active.sync="addUserModel"
    >
      <div class="popup-calender">
        <el-form :model="addUser" ref="addUser">
          <h6 class="mb-1">الاسم</h6>
          <el-form-item
            prop="name"
            :rules="[{ required: true, message: 'الاسم مطلوب' }]"
          >
            <el-input placeholder="الاسم" v-model="addUser.name"></el-input>
          </el-form-item>

          <h6 class="mb-1">الموبايل</h6>
          <el-form-item
            prop="mobile"
            :rules="[{ required: true, message: 'الموبايل مطلوب' }]"
          >
            <el-input
              placeholder="الموبايل"
              v-model="addUser.mobile"
            ></el-input>
          </el-form-item>

          <h6 class="mb-1">التليفون</h6>
          <el-form-item
            prop="phone"
            :rules="[{ required: true, message: 'الموبايل مطلوب' }]"
          >
            <el-input placeholder="الموبايل" v-model="addUser.phone"></el-input>
          </el-form-item>

          <h6 class="mb-1">العنوان</h6>
          <el-form-item
            prop="address"
            :rules="[{ required: true, message: 'العنوان مطلوب' }]"
          >
            <el-input
              placeholder="العنوان"
              v-model="addUser.address"
            ></el-input>
          </el-form-item>

          <!-- <h6 class="mb-1">القسط</h6>
          <el-form-item
            prop="init_balance"
            :rules="[{ required: true, message: 'القسط مطلوب' }]"
          >
            <el-input
              placeholder="القسط"
              v-model="addUser.init_balance"
            ></el-input>
          </el-form-item> -->

          <el-form-item>
            <div>
              <el-button type="primary" @click="onSubmit('addUser')">
                إضافة
              </el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import axiosApi from "@/plugins/axios.js";
export default {
  data() {
    return {
      search: "",
      clients: [],
      addUser: {},
      addUserModel: false,
      allClients: [],
     
    };
  },
  created() {
    this.getAllClients();
  },
  methods: {
     destroy(client) {
      const loading = this.$loading({
        lock: true,
        text: "جاري تحميل البيانات",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
                axiosApi
                  .delete("clients/" + client.id)
                  .then(res => {
                   this.getAllClients();
                    this.$snotify.success("تم حذف الشريك بنجاح");
                  })
                  .catch(e => {
                    
                    console.log(e);
                  }) .finally(() => loading.close());
            
        
      
    },
    searchInClients() {
      //   const loading = this.$loading({
      //   lock: true,
      //   text: false,
      //   spinner: "el-icon-loading",
      //   background: "rgba(255,255,255,.7)",
      //   customClass: "fullscreen-loading",
      // });
      this.clients = this.allClients.filter((ele) => {
        return (
          ele.name.includes(this.search)
        );
      });
      // loading.close();

    },
      convertNumber(val){
      if(val>0){
      return Number(val).toLocaleString('en-US');
      }else{
        return "";
      }

    },
    getAllClients() {
      const loading = this.$loading({
        lock: true,
        text: false,
        spinner: "el-icon-loading",
        background: "rgba(255,255,255,.7)",
        customClass: "fullscreen-loading",
      });
      axiosApi.get("/clients").then((res) => {
        this.clients = res.data;
      
        this.clients.map((client)=>{
          let  totalInstallmentAmount=0;
          let   totalPaiedAmount=0;

          client.units.map((unit)=>{
          unit.unit_installment.map((installment)=>{
            // console.log("------ installment.amount -----",installment.amount)
            totalInstallmentAmount+=installment.amount;
            totalPaiedAmount+=installment.paied;
            // console.log("------ totalInstallmentAmount -----",this.totalInstallmentAmount)

          })

         
        })
        client['totalInstallmentAmount']=+totalInstallmentAmount;
        client['totalPaiedAmount']=+totalPaiedAmount;        })
        this.allClients = res.data;
      }).finally(() => loading.close());
    },
    onSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
            const loading = this.$loading({
        lock: true,
        text: false,
        spinner: "el-icon-loading",
        background: "rgba(255,255,255,.7)",
        customClass: "fullscreen-loading",
      });
          axiosApi
            .post(`/clients`, this.addUser)
            .then(() => {
              this.$vs.notify({
                title: "تم بنجاح",
                position: "top-center",
                color: "success",
                text: "تم الاضافة بنجاح",
              });
              this.addUserModel = false;
              this.getAllClients();
            })
            .catch((err) => {
              if (err.response.status == 500) {
                this.$vs.notify({
                  title: " عذرا",
                  position: "top-center",
                  color: "danger",
                  text: "حدث خطا ما",
                });
              }

              if (err.response.status == 400) {
                this.$vs.notify({
                  title: "هذا العميل الاسم / الهاتف / التليفون موجود من قبل",
                  position: "top-center",
                  color: "danger",
                  text: "حدث خطا ما",
                });
              }

            })
            .finally(() => loading.close());
        }
      });
    },
  },
};
</script>

<style lang="scss">
.our-clients {
  padding: 10px;
  .client-header {
    justify-content: space-between;
  }
  .user {
    background: #fff;
    padding: 15px;
    border-radius: 10px;
  }
  .head {
    gap: 10px;
    svg {
      padding: 5px;
      background-color: rgba(var(--vs-primary), 0.3) !important;
      border-radius: 5px;
      path {
        fill: #fff;
      }
    }
  }
}
</style>